var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-integration"},[_c('div',{staticClass:"container-integration-content"},[(_vm.icon)?_c('div',{staticClass:"plugin"},[_c('em',{class:_vm.icon})]):_vm._e(),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',{staticClass:"content"},[_vm._t("default")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }